<script setup lang="ts" generic="Item extends { id: string | number; label: string }">
import type { Sizes } from '@ui/styles'
import Chip from '@ui/components/chip-group/Chip.vue'
import { ChipVariant } from '@ui/styles'

const props = withDefaults(
  defineProps<{
    options?: Item[]
    size?: typeof Sizes.Luke | typeof Sizes.HanSolo | typeof Sizes.R2D2
    disabled?: boolean
    init?: boolean
  }>(),
  {
    options: () => [],
    disabled: false,
    init: true,
  },
)

const selected = defineModel<Item['id']>({ default: () => '' })

if (props.init) {
  const firstOption = props.options[0]
  if (!selected.value && firstOption) {
    selected.value = firstOption.id
  }
}
</script>

<template lang="pug">
.flex.gap-12.flex-wrap
  Chip(
    v-for="o of options"
    :key="o.id"
    :label="o.label"
    :size="size"
    :variant="selected === o.id ? ChipVariant.Selected : ChipVariant.Primary"
    :aria-pressed="selected === o.id"
    :disabled="disabled"
    @click="selected = o.id"
  )
</template>
